import { render, staticRenderFns } from "./AmbitLoader.vue?vue&type=template&id=1d5b5902"
import script from "./AmbitLoader.vue?vue&type=script&lang=js"
export * from "./AmbitLoader.vue?vue&type=script&lang=js"
import style0 from "./AmbitLoader.vue?vue&type=style&index=0&id=1d5b5902&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports